// utils/populateItemsUtil.js

export const itemHandlersFactory = ({
  getCalibrationList,
  getServiceList,
  getPartsList,
  getLabourList,
  setAvailableCalibrations,
  setAvailableServices,
  setAvailableParts,
  setAvailableLabour,
  transformToMap
}) => {
  const itemHandlers = {
    calibrations: {
      fetch: getCalibrationList,
      set: setAvailableCalibrations,
      selectedKey: 'calibrations'
    },
    services: {
      fetch: getServiceList,
      set: setAvailableServices,
      selectedKey: 'services'
    },
    parts: {
      fetch: getPartsList,
      set: setAvailableParts,
      selectedKey: 'parts'
    },
    labor: {
      fetch: getLabourList,
      set: setAvailableLabour,
      selectedKey: 'labours'
    }
  }

  const handleItems = async (type, ccid, qwi_id, selected = [], extraParams = {}) => {
    const handler = itemHandlers[type]
    if (!handler) {
      console.warn(`Unknown type: ${type}`)
      return
    }

    const data = await handler.fetch({
      ccid,
      qwi_id,
      ...extraParams
    })

    const selectedItemNums = selected.map((item) => item.itemNum)
    handler.set(transformToMap(data, selectedItemNums))
  }

  const populateSelectableItems = async (type, ccid, qwi_id, selected = {}, extraParams = {}) => {
    try {
      const handler = itemHandlers[type]
      if (!handler) return

      const selectedItems = selected[handler.selectedKey] || []
      await handleItems(type, ccid, qwi_id, selectedItems, extraParams)
    } catch (error) {
      console.error(`Error populating ${type}:`, error)
    }
  }

  return {
    populateSelectableItems
  }
}
